module.exports = "fonts/glyphicons-halflings-regular.woff2";